import { render } from "./DomandaInoltrata.vue?vue&type=template&id=319fa566"
import script from "./DomandaInoltrata.vue?vue&type=script&lang=js"
export * from "./DomandaInoltrata.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\miche\\Documents\\projects\\wiper_frontend_client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__